import React from "react";
import { MARQUEE } from "@/data/content";

export const Marquee = ({ tone = "forest" }) => {
  const items = [...MARQUEE, ...MARQUEE];
  const bg = tone === "forest" ? "bg-forest text-cream" : "bg-ochre text-forest";
  return (
    <div data-testid="marquee" className={`${bg} overflow-hidden border-y border-ink/10 py-4 select-none`}>
      <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="font-display text-xl italic md:text-2xl">{t}</span>
            <span className="text-lg opacity-60">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
